export const gdpr = {
    canSetCookiePreferences: () => false,
    shouldShowCookiePreferences: () => false,
    setCookiePreferences: () => {},
    getCookiePreferences: () => ({ allowAnalytics: true, allowAdvertising: true }),
};
